<!-- <div *ngIf="overlay" class="overlay"></div> -->
<div class="spinner">
  <div class="cube1"></div>
  <div class="cube2"></div>
</div>